(function($){
  $(function(){
    $('.flexslider').flexslider({
      animation: "slide",
      controlNav: false,
      directionNav: false,
      slideshowSpeed: 12000
    });
    function drop_fb_pixel() {
      try {
          fbq('track', 'ViewContent');
      }
      catch (err) {
          setTimeout(function () { drop_fb_pixel(); }, 3000);
      }
    }
    $(document).ready(function () {
        drop_fb_pixel();
    });
  });
})(jQuery);
